import { render, staticRenderFns } from "./BtnAtualizarProjetoAcao.vue?vue&type=template&id=5396bcbe&"
import script from "./BtnAtualizarProjetoAcao.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarProjetoAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports